export const setCandidatos = (candidatos) => ({
    type: "SET_CANDIDATOS",
    payload: candidatos
})